import { ReadonlyText } from "@sportactics/board-editing";

import { TextModel } from "./text-model";

export function convertTextToModel(text: ReadonlyText): TextModel {
  return {
    id: text.id,
    position: text.position,
    value: text.value,
    color: text.color,
    size: text.size,
  };
}
